import React from 'react';
import { connect } from 'react-redux';










const FeatureToggle = ({
  featureActivated,
  children
}) => featureActivated ? /*#__PURE__*/React.createElement(React.Fragment, null, children) : null;

FeatureToggle.defaultProps = {
  featureActivated: false
};

function mapStateToProps({ settings }, ownProps) {
  const features = settings.collection.get('features');

  return {
    featureActivated: features ? Boolean(features.getIn(ownProps.feature.split('.'))) : false
  };
}

const container = connect(mapStateToProps)(FeatureToggle);

export { container as FeatureToggle };